

















import { Vue, Component, PropSync } from 'vue-property-decorator'
import { ScreenText } from '@/lang/ScreenText'
import RemovalModal from '@/popupcomponents/RemovalModal.vue'

@Component({
  components: {
    RemovalModal
  }
})
export default class RemoveApplicationAlert extends Vue {
  @PropSync('isVisible') isVisibleSync!: boolean
  public readonly screenText: ScreenText = new ScreenText()
}
